/* Shared feedback helpers — labels, colours, icons. */
import {
    Bug, Lightbulb, HelpCircle, Heart,
    Inbox, Loader2, CheckCircle2, RotateCw,
} from "lucide-react";

export const FEEDBACK_TYPES = {
    bug: { label: "Bug", color: "var(--jr-danger)", icon: Bug,
        desc: "Iets werkt niet zoals het hoort." },
    suggestion: { label: "Suggestie", color: "var(--jr-brand)", icon: Lightbulb,
        desc: "Idee om de tool beter te maken." },
    question: { label: "Vraag", color: "var(--jr-info)", icon: HelpCircle,
        desc: "Hulp nodig of iets onduidelijk?" },
    compliment: { label: "Compliment", color: "#22c55e", icon: Heart,
        desc: "Iets dat je geweldig vindt." },
};

export const FEEDBACK_STATUS = {
    new: { label: "Nieuw", color: "var(--jr-text-2)", icon: Inbox,
        progress: 0, desc: "Wachtend op triage door admin." },
    in_progress: { label: "In behandeling", color: "var(--jr-amber)", icon: Loader2,
        progress: 40, desc: "Admin is hiermee bezig." },
    retesting: { label: "Te hertesten", color: "#a855f7", icon: RotateCw,
        progress: 75, desc: "Fix gedeployed — melder moet valideren." },
    resolved: { label: "Opgelost", color: "#22c55e", icon: CheckCircle2,
        progress: 100, desc: "Afgewerkt — check je notificaties." },
};

export const FEEDBACK_PRIORITY = {
    p0: { label: "P0 — Blocker", color: "var(--jr-danger)" },
    p1: { label: "P1 — Belangrijk", color: "var(--jr-amber)" },
    p2: { label: "P2 — Nice-to-have", color: "var(--jr-text-2)" },
};

export function fmtDate(d) {
    try {
        return new Date(d).toLocaleString("nl-BE", {
            day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
        });
    } catch { return ""; }
}

